export const handleKeyDown =
  (onContinue: () => void) => (event: React.KeyboardEvent) => {
    const keyCode = event.keyCode || event.key;

    if ((keyCode === 13 || keyCode === "Enter") && !event.repeat) {
      event.preventDefault();
      onContinue();
    }
  };
